import type { EndpointDefinition } from '../contracts';
import { ListDeletedCompaniesQuerySchema, ListDeletedCompaniesResponseSchema } from './admin-companies.schemas';

/**
 * Admin company contract group (IMM-1096.4). The cross-tenant operator surface,
 * mounted as `contracts.adminCompanies` at `/v1/admin/companies`. Admin-tier:
 * `requireAdmin` at the presenter and `backoffice:relationship:*` at the
 * route-builder (default-deny). Not part of the published API surface.
 */
export const adminCompanyContracts = {
  listDeleted: {
    method: 'GET',
    path: '/v1/admin/companies/deleted',
    query: ListDeletedCompaniesQuerySchema,
    response: { 200: ListDeletedCompaniesResponseSchema },
    permission: 'backoffice:relationship:company-read',
    description:
      'Every soft-deleted company across all workspaces, newest deletion first, with the workspace name and who deleted it. Optionally narrowed to one workspace with `?workspaceId=`.',
  },
} as const satisfies Record<string, EndpointDefinition>;
